import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { register } from 'swiper/element/bundle';

// Silence console output on production hosts to cut the noise Lighthouse's
// "errors-in-console" audit counts. The webpack `browser` builder here has no
// fileReplacements/enableProdMode wired up, so we gate on hostname rather than
// a build-time flag — localhost and staging keep full logging for debugging.
const PROD_HOSTS = ['infithra.com', 'www.infithra.com'];
if (typeof window !== 'undefined' && PROD_HOSTS.includes(window.location.hostname)) {
  const noop = () => {};
  (['log', 'info', 'debug', 'warn', 'error'] as const).forEach((level) => {
    console[level] = noop;
  });
}

register()
function bootstrap() {
    platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
  };


 if (document.readyState === 'complete') {
   bootstrap();
 } else {
   document.addEventListener('DOMContentLoaded', bootstrap);
 }
 
